import React, { useState, useEffect, useContext } from "react";

import {
  IconButton,
  Paper,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Stack,
  Button,
  Tooltip,
} from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { isEmpty } from "lodash";
import { DataContext } from "../../../context/DataContext";
import { isAccess, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import NoData from "../../../components/NoData";
import ListFooter from "../../../components/ui/ListFooter";

import SmallModal from "../../../components/modals/SmallModal";

import { getSucursalListAsync } from "../../../api/Sucursal";
import AddSucursal from "./AddSucursal";
import EditSucursal from "./EditSucursal";
import { getTokens } from "../../../theme";

const SucursalList = () => {
  const [sucursalList, setSucursalList] = useState([]);
  const [selectedSucursal, setSelectedSucursal] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [localReload, setLocalReload] = useState(false);

  const { access, setIsLoading, setIsUnautorized, isDarkMode } = useContext(DataContext);
  const t = getTokens(isDarkMode);

  const token = getToken();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getSucursalListAsync(token);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setSucursalList(result.data.result);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localReload]);

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsperPage] = useState(10);
  const indexLast = currentPage * itemsperPage;
  const indexFirst = indexLast - itemsperPage;
  const currentItem = sucursalList.slice(indexFirst, indexLast);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <Paper sx={{ overflow: "hidden" }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="flex-end"
          alignItems={{ xs: "stretch", sm: "center" }}
          spacing={2}
          flexWrap="wrap"
          sx={{ padding: "18px 22px", borderBottom: "1px solid", borderColor: "divider" }}
        >
          {isAccess(access, "CREAR SUCURSAL") ? (
            <Button
              onClick={() => setShowModal(true)}
              startIcon={<AddRoundedIcon />}
              variant="contained"
              color="primary"
              sx={{ whiteSpace: "nowrap", height: "44px" }}
            >
              Agregar sucursal
            </Button>
          ) : null}
        </Stack>

        {isEmpty(currentItem) ? (
          <NoData />
        ) : (
          <>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table sx={{ minWidth: 480 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">#</TableCell>
                    <TableCell>Sucursal</TableCell>
                    {isAccess(access, "EDITAR SUCURSAL") ? (
                      <TableCell align="center">Editar</TableCell>
                    ) : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {currentItem.map((row) => {
                    const { id, description } = row;
                    return (
                      <TableRow key={id} hover>
                        <TableCell align="center" sx={{ color: "text.disabled", fontWeight: 600 }}>
                          {id}
                        </TableCell>
                        <TableCell sx={{ fontWeight: 700, color: "text.primary" }}>{description}</TableCell>
                        {isAccess(access, "EDITAR SUCURSAL") ? (
                          <TableCell align="center">
                            <Tooltip title="Editar">
                              <IconButton
                                size="small"
                                sx={{
                                  width: 32,
                                  height: 32,
                                  borderRadius: "9px",
                                  border: `1px solid ${t.fieldLine}`,
                                  backgroundColor: t.field,
                                  color: "warning.main",
                                }}
                                onClick={() => {
                                  setSelectedSucursal(row);
                                  setShowEditModal(true);
                                }}
                              >
                                <EditRoundedIcon sx={{ fontSize: 15 }} />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        ) : null}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>

            <ListFooter
              data={sucursalList}
              currentCount={currentItem.length}
              indexFirst={indexFirst}
              paginate={paginate}
              itemsperPage={itemsperPage}
              noun="sucursales"
            />
          </>
        )}
      </Paper>

      <SmallModal
        titulo={"Agregar Sucursal"}
        isVisible={showModal}
        setVisible={setShowModal}
      >
        <AddSucursal
          setShowModal={setShowModal}
          localReload={localReload}
          setLocalReload={setLocalReload}
        />
      </SmallModal>

      <SmallModal
        titulo={`Editar sucursal`}
        isVisible={showEditModal}
        setVisible={setShowEditModal}
      >
        <EditSucursal
          selected={selectedSucursal}
          setShowModal={setShowEditModal}
          localReload={localReload}
          setLocalReload={setLocalReload}
        />
      </SmallModal>
    </div>
  );
};

export default SucursalList;
